import axiosInstance from "../api/axiosInstance";

const customerService = new (class CustomerService {
  async getCustomerProfile() {
    const response = await axiosInstance.get("/CustomerProfile");
    return response.data;
  }

  async updateCustomerProfile(profileData) {
    const response = await axiosInstance.put("/CustomerProfile", profileData);
    return response.data;
  }

  async changePassword(passwordData) {
    const response = await axiosInstance.post("/CustomerProfile/ChangePassword", passwordData);
    return response.data;
  }
  
  async getCustomerAddresses() {
    const response = await axiosInstance.get("/CustomerAddresses");
    return response.data;
  }

  async updateCustomerAddresses(addressesData) {
    const response = await axiosInstance.put("/CustomerAddresses", addressesData);
    return response.data;
  }
  
  async addCustomerAddress(addressData) {
    const response = await axiosInstance.post("/CustomerAddresses", addressData);
    return response.data;
  }
  
  async deleteCustomerAddress(addressId) {
    const response = await axiosInstance.delete(`/CustomerAddresses/${addressId}`);
    return response.data;
  }
  
  async setDefaultAddress(addressId, addressType) {
    const response = await axiosInstance.put(`/CustomerAddresses/${addressId}/default`, { addressType });
    return response.data;
  }

  async updateCustomerAddress(addressId, addressData) {
    const response = await axiosInstance.put(`/CustomerAddresses/${addressId}`, addressData);
    return response.data;
  }
})();

export default customerService; 